/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeIncomeChangeDocumentationPage() {
   var onSubmit = false;
   customValidationInit(onSubmit);
   aspControlValidationInit();
};
